const EMAIL_REGEX = /^(?=((?:[A-Za-z0-9!#$%&'+=?^{|}~-]?[.]?[A-Za-z0-9!#$%&'*+=?^_{|}~-]+)+|"[A-Za-z0-9!@#$%&'+=?^`{|}~.\-\s]*"))\1@{1}(?:(?:([A-Za-z0-9][-]?(?=[A-Za-z0-9]*))*[A-Za-z0-9]+\.)+[A-Za-z]{2,})$/;
const PHONE_START_REGEXP = /(^[+7|7|8]{1,2})/s;

export { EMAIL_REGEX, PHONE_START_REGEXP };
//# sourceMappingURL=regExp.js.map
